import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { htmlUrls } from '@shared/utils/router-paths';
import { SignalHubService } from '@shared/service/signal_services/signal-hub.service';
import { Observable, of } from 'rxjs';
import { LocalRepository } from '@shared/helper/local-repository';
import { ACCESS_TOKEN_KEY } from 'constants/storage-keys';

export const authGuard: CanActivateFn = (): Observable<boolean> => {
  const repo: LocalRepository = inject(LocalRepository);
  const router: Router = inject(Router);
  const signalrService: SignalHubService = inject(SignalHubService);

  const isUserLoggedIn = repo.getCookieItem(ACCESS_TOKEN_KEY);
  if (!isUserLoggedIn) {
    router.navigate([htmlUrls.home]);
    return of(false);
  } else {
    if (repo.IsInBrowser) {
      signalrService.startConnection();
    }
    return of(true);
  }
};
